import React from 'react';
export function SubscriberRemoveIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), React.createElement("g", {
    clipPath: "url(#svg__05520__clip0)"
  }, React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.06 15.437C13.453 14.314 15 11.631 15 8.5 15 4.358 12.636 1 8.5 1S2 4.358 2 8.5c0 3.13 1.547 5.813 3.94 6.937-.219.734-1.01 1.027-1.897 1.356C2.641 17.313 1 17.922 1 20.5v2h15v-2c0-2.578-1.641-3.187-3.043-3.707-.887-.329-1.678-.622-1.897-1.356zM8.5 14c2.39 0 4.5-2.14 4.5-5.5 0-1.71-.489-3.108-1.248-4.039C11.027 3.573 9.972 3 8.5 3c-1.473 0-2.527.573-3.252 1.461C4.488 5.391 4 6.791 4 8.5 4 11.86 6.11 14 8.5 14z"
  }), React.createElement("path", {
    d: "M16 7v2h8V7h-8z"
  })), React.createElement("defs", null, React.createElement("clipPath", {
    id: "svg__05520__clip0"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))));
}